module.exports = __webpack_public_path__ + "static/media/map-marker-slash.7005549f.svg";